import { useState, useEffect, ReactNode } from 'react';
import { useMsal } from '@azure/msal-react';
import { SignInSplash } from '@/components/auth/SignInSplash';
import { postUsersProvision } from '@/api/auth/registration/registration';
import { logger } from '@/services/logger';

/**
 * Provider that ensures user is provisioned before rendering children
 */
export function ProvisioningProvider({ children }: { children: ReactNode }) {
  const { accounts } = useMsal();
  const [provisioningDone, setProvisioningDone] = useState(false);

  const account = accounts[0];

  useEffect(() => {
    const provisionUser = async () => {
      logger.info('Provisioning user', {
        context: 'ProvisioningContext',
        email: account.username,
      });

      try {
        await postUsersProvision({
          email: account.username,
          firstName: (account.idTokenClaims?.given_name as string | undefined) ?? '',
          lastName: (account.idTokenClaims?.family_name as string | undefined) ?? '',
        });

        logger.info('User provisioned successfully', {
          context: 'ProvisioningContext',
        });
      } catch (err) {
        logger.warn('User provisioning call failed', {
          context: 'ProvisioningContext',
          error: err instanceof Error ? err.message : String(err),
        });
      } finally {
        setProvisioningDone(true);
      }
    };

    void provisionUser();
  }, [account.homeAccountId]);

  if (!provisioningDone) {
    return <SignInSplash />;
  }

  return <>{children}</>;
}
